"use client";

import React from "react";
import NextLink from "next/link";
import {Locale} from "@/i18n-config";
import type {ContentLink as ContentLinkProps} from "@docid/types/src/payload-types";
import {localizePathname} from "@/utils/locales";
import {SearchParamsBoundary} from "@/components/navigation/SearchParamsBoundary";
import clsx from "clsx";
import {InlineText} from "@/components/content/common/InlineText";

type Props = {
    lang: Locale;
    dictionary: any;
    className?: string;
    block: ContentLinkProps;
    position?: number;
};

function ContentLinkContent({ lang, dictionary, className, block, position, searchParams } : Props & {searchParams: URLSearchParams}) {
    switch(block.linkType) {
        case "Internal":
            return (
                <NextLink
                    className={clsx(className)}
                    href={localizePathname(lang, block.pathname!, searchParams)}
                    target={block.openInNewTab === "Yes" ? "_blank" : "_self"}
                    rel={block.noFollow ? "nofollow" : ""}>
                    <InlineText value={block.name} />
                </NextLink>
            );
        case "External":
            return (
                <a
                    className={clsx(className)}
                    href={block.externalLink!}
                    target={block.openInNewTab === "Yes" ? "_blank" : "_self"}
                    rel={block.noFollow ? "nofollow" : ""}>
                    <InlineText value={block.name} />
                </a>
            );
        default:
            return (
                <div className={clsx(className)}>
                    <InlineText value={block.name} />
                </div>
            );
    }
}

export function ContentLink(props: Props) {
    return <SearchParamsBoundary>{searchParams => <ContentLinkContent {...props} searchParams={searchParams}/>}</SearchParamsBoundary>;
}
